import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./assets/translations/en.json";
import fa from "./assets/translations/fa.json";

// Initialize i18n with fallback language synchronously
i18n.use(initReactI18next).init({
  resources: {
    fa: {
      common: fa.common,
    },
  },
  lng: "fa", // Default language
  fallbackLng: "fa", // Fallback language
  ns: ["common"], // Default namespace
  defaultNS: "common",
});

export default i18n;
